<template>
  <div class="shop-staff-msg-list">
    <el-card shadow="never" class="search-card">
      <div slot="header">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" :model="queryParams">
        <el-form-item label="消息类型">
          <el-select v-model="queryParams.msgType" placeholder="请选择消息类型" clearable style="width: 150px">
            <el-option label="系统通知" value="1001" />
            <el-option label="订单提醒" value="2002" />
            <el-option label="退款通知" value="3003" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never" class="table-card">
      <div slot="header" class="flex justify-between">
        <span>店铺消息</span>
      </div>
      <el-table :data="list" v-loading="loading" border stripe @row-click="handleRowClick">
        <el-table-column prop="title" label="标题" min-width="150" />
        <el-table-column prop="content" label="内容" min-width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.content ? scope.row.content.substring(0, 50) + (scope.row.content.length > 50 ? '...' : '') : '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="msgType" label="消息类型" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.msgType === '1001'" type="info">系统通知</el-tag>
            <el-tag v-else-if="scope.row.msgType === '2002'" type="warning">订单提醒</el-tag>
            <el-tag v-else-if="scope.row.msgType === '3003'" type="danger">退款通知</el-tag>
            <el-tag v-else>{{ scope.row.msgType }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="staffName" label="发送者" width="100" />
        <el-table-column prop="createTime" label="创建时间" width="160" />
        <el-table-column prop="isRead" label="状态" width="80">
          <template slot-scope="scope">
            <el-tag :type="scope.row.isRead === '1' ? 'success' : 'danger'" size="small">
              {{ scope.row.isRead === '1' ? '已读' : '未读' }}
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handlePageChange"
        :current-page.sync="queryParams.page"
        :page-size="queryParams.row"
        :total="total"
        :page-sizes="[10, 20, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        class="pagination-container"
      />
    </el-card>

    <el-dialog
      title="消息详情"
      :visible.sync="msgDialogVisible"
      width="600px"
      @close="handleDialogClose">
      <div v-if="currentMsg">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="标题" :span="2">{{ currentMsg.title }}</el-descriptions-item>
          <el-descriptions-item label="消息类型">
            <el-tag v-if="currentMsg.msgType === '1001'">系统通知</el-tag>
            <el-tag v-else-if="currentMsg.msgType === '2002'">订单提醒</el-tag>
            <el-tag v-else-if="currentMsg.msgType === '3003'">退款通知</el-tag>
            <span v-else>{{ currentMsg.msgType }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="发送者">{{ currentMsg.staffName || '-' }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="currentMsg.isRead === '1' ? 'success' : 'danger'">{{ currentMsg.isRead === '1' ? '已读' : '未读' }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="创建时间">{{ currentMsg.createTime }}</el-descriptions-item>
          <el-descriptions-item label="内容" :span="2">
            <div style="white-space: pre-wrap; line-height: 1.6">{{ currentMsg.content }}</div>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="msgDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listShopStaffMsg, readShopStaffMsg } from '@/api/shop/shopStaffMsgApi'
import { getCurrentShop } from '@/utils/vc'

export default {
  name: 'ShopStaffMsgList',
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      msgDialogVisible: false,
      currentMsg: null,
      queryParams: {
        page: 1,
        row: 10,
        shopId: '',
        msgType: ''
      }
    }
  },
  created() {
    this.queryParams.shopId = getCurrentShop().shopId
    this.fetchList()
  },
  methods: {
    async fetchList() {
      this.loading = true
      try {
        const res = await listShopStaffMsg(this.queryParams)
        this.list = res.data || []
        this.total = res.total || 0
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.queryParams.page = 1
      this.fetchList()
    },
    handlePageChange(val) {
      this.queryParams.page = val
      this.fetchList()
    },
    handleSizeChange(val) {
      this.queryParams.row = val
      this.queryParams.page = 1
      this.fetchList()
    },
    async handleRowClick(row) {
      this.currentMsg = row
      this.msgDialogVisible = true
      if (row.isRead !== '1') {
        try {
          await readShopStaffMsg({ msgId: row.msgId })
          row.isRead = '1'
        } catch (e) {
          console.error('标记已读失败', e)
        }
      }
    },
    handleDialogClose() {
      this.currentMsg = null
    }
  }
}
</script>

<style scoped>
.search-card {
  margin-bottom: 16px;
}
.table-card {
  margin-bottom: 16px;
}
.pagination-container {
  margin-top: 16px;
  text-align: right;
}
</style>
